import { IsEmail, IsJWT, IsNotEmpty, IsString } from "class-validator";

export class ChangePasswordDto {
    @IsString()
    @IsNotEmpty()
    oldPassword!: string;

    @IsString()
    @IsNotEmpty()
    newPassword!: string;
}

export class ForgetPasswordDto {
    @IsEmail()
    @IsNotEmpty()
    email!: string;
}

export class ResetPasswordDto {
    @IsString()
    @IsNotEmpty()
    password!: string;

    @IsJWT()
    @IsNotEmpty()
    token!: string;
}

export class EmailVerificationDto {
    @IsJWT()
    @IsNotEmpty()
    token!: string;
}
